var map = {
	"./arrow.png": "81c6",
	"./fb-icon.png": "f6dc",
	"./icon0.png": "1c51",
	"./icon1.png": "ef8d",
	"./icon2.png": "6646",
	"./icon3.png": "b84b",
	"./icon4.png": "5064",
	"./share.png": "38c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d94d";